export const LumenReportConstants = {
    ALL_LUMEN_REPORT_CURRENT_PAGE: "ALL_LUMEN_REPORT_CURRENT_PAGE",
    ALL_LUMEN_REPORT_LIMIT_PER_PAGE: "ALL_LUMEN_REPORT_LIMIT_PER_PAGE",

    GET_ALL_LUMEN_REPORT_SUCCESS: "GET_ALL_LUMEN_REPORT_SUCCESS",
    ALL_LUMEN_REPORT_LIMIT: "ALL_LUMEN_REPORT_LIMIT",
    GET_ALL_LUMEN_REPORT_ERROR: "GET_ALL_LUMEN_REPORT_ERROR",
    ALL_LUMEN_REPORT_LOADING: "ALL_LUMEN_REPORT_LOADING",
};
